import React from 'react';
import styled from 'styled-components';

import { Logo } from 'src/components/Images/Logo';
import { LoyaltyCodes } from 'src/constants/loyaltyPrograms';

import { LoyaltyProgram } from './BookingSummary.interface';

const logoLoyaltyMapping = {
  [LoyaltyCodes.QFF]: <Logo name="qantasFrequentFlyer" />,
};

export const BookingSummaryLoyaltyPrograms = ({
  loyaltyPrograms,
}: {
  loyaltyPrograms: LoyaltyProgram[];
}) => (
  <>
    {loyaltyPrograms.map((loyaltyProgram) => {
      const Logo = logoLoyaltyMapping[loyaltyProgram?.loyaltyProgram?.code];
      const points =
        (loyaltyProgram?.points?.base ?? 0) +
        (loyaltyProgram?.points?.bonus ?? 0);
      if (!Logo || !loyaltyProgram?.loyaltyProgram?.displayName || !points) {
        return <></>;
      }

      return (
        <LoyaltyProgramContainer
          key={`bookingSummaryloyaltyProgram-${loyaltyProgram.loyaltyProgram.code}`}
        >
          {Logo}
          <LoyaltyProgramSpan>
            Earn {points} {loyaltyProgram?.loyaltyProgram?.displayName} Points
            with this booking †
          </LoyaltyProgramSpan>
        </LoyaltyProgramContainer>
      );
    })}
  </>
);

export const LoyaltyProgramContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin: 1rem 0;
  height: 3.6rem;
  gap: 0.8rem;

  svg {
    height: 100%;
    width: initial;
  }
`;

export const LoyaltyProgramSpan = styled.span`
  color: ${({ theme: { colors } }) => colors.b2cBlack};
  font-size: 1.28rem;
  font-weight: 400;
  line-height: 1.8rem;
  align-self: center;
`;
